var Html;
Html = {};

Html.tel = function( phone, linkPhone ) {
	if ( undefined === linkPhone ) {
		linkPhone = "" + phone;

		// remove "-", " ", "(", ")"
		linkPhone = linkPhone.replace( /[()\s-]/ig, '' );
	}
	return '<a href="tel:' + ( linkPhone ) + '" class="phone" data-tel-plugin target="_blank">' + ( phone ) + '</a>';

};
